import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="versions" id="versions"></a>
    <h1 {...{
      "id": "requireuxpversions"
    }}>{`require('uxp').versions`}</h1>
    <p>{`Version information. To get an instance: require("uxp").versions`}</p>
    <a name="versions-uxp" id="versions-uxp"></a>
    <h2 {...{
      "id": "uxp--string"
    }}>{`uxp ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Returns the version of UXP. For example, uxp-6.0.0`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>
    <a name="versions-plugin" id="versions-plugin"></a>
    <h2 {...{
      "id": "plugin--string"
    }}>{`plugin ⇒ `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Returns the version of the plugin. This matches the version as specified in your plugin's manifest.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      